export default {
  labelUseScene: '授权范围',
  labelUseMethod: '购买用途',
  labelAuthArea: '授权地域',
  labelAuthTime: '授权期限',

  tryVersionText: '试听版本',
  highQualityVersionText: '高清版本',
}